import { without } from 'lodash'
import { routes } from '../config/index'
import Cookie from 'js-cookie'

export const array2Tree = (array) => {
  // TODO 多层目录结构 需要迭代
  //map 用id和当前项建立映射
  let map = {}
  // reduce 方法里的参数顺序：初始值 当前项 索引 当前数组
  array.reduce((initVal, item) => {
    initVal[item.id] = item
    return initVal
  }, map)
  return array.reduce((arr, item) => {
    //先获取当前项的pid
    let pid = item.pid
    //获取当前项的父节点
    let parent = map[pid]
    //父节点存在就往父节点的children上添加当前项
    if (parent) {
      parent.children ? parent.children.push(item) : (parent.children = [item])
    } else {
      arr.push(item)
    }
    return arr
  }, [])
}

export const menuList2Tree = (array) => {
  // TODO 多层目录结构 需要迭代
  //map 用id和当前项建立映射
  let map = {}
  // reduce 方法里的参数顺序：初始值 当前项 索引 当前数组
  array.reduce((initVal, item) => {
    initVal[item.menuId] = item
    return initVal
  }, map)
  return array.reduce((arr, item) => {
    //先获取当前项的pid
    let pid = item.parentId
    //获取当前项的父节点
    let parent = map[pid]
    //父节点存在就往父节点的children上添加当前项
    if (parent) {
      parent.children ? parent.children.push(item) : (parent.children = [item])
    } else {
      arr.push(item)
    }
    return arr
  }, [])
}

export const array2Tree2 = (array) => {
  let idToNodeMap = new Map()

  array.forEach((node) => {
    idToNodeMap.set(node.id, node)
  })

  array.forEach((node) => {
    if (node.id === -1) return
    let parent = idToNodeMap.get(node.pid)
    if (!parent) return
    if (!parent.children) {
      parent.children = []
    }
    parent.children.push(node)
  })

  let tree = [...idToNodeMap.values()].filter((node) => node.pid === -1)
  return tree
}

export function getBreadcrumbList(name) {
  let currentRoute = routes.filter((r) => r.name === name)[0]
  if (!currentRoute) return []
  let breadcrumbList = [{ ...currentRoute }]

  while (true) {
    let father = routes.filter((r) => r.id === (currentRoute.breadcrumbPid || currentRoute.pid))[0]
    if (!father) break
    breadcrumbList.unshift({ ...father })
    currentRoute = father
  }
  return breadcrumbList
}

export function setToken(token, secret) {
  let expires = new Date(new Date().getTime() + 7 * 24 * 60 * 60 * 1000)
  Cookie.set('token', token, {
    expires
  })
  Cookie.set('secret', secret, {
    expires
  })
}

export function removeToken() {
  Cookie.remove('token')
  Cookie.remove('secret')
}

export function getToken() {
  return Cookie.get('token')
}

export function getSecret() {
  return Cookie.get('secret')
}
